import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [

  {
    path: "/",
    name: "home",
    component: () => import("@/components/CleanForm")
  },
  {
    path: "/userOrders",
    name: "userOrders",
    component: () => import("@/components/orders/UserOrders")
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/components/authentication/LoginForm")
  },
  {
    path: "/logout",
    name: "logout",
    component: () => import("@/components/authentication/LoginForm")
  },
  {
    path: "/userDashboard",
    name: "userDashboard",
    component: () => import("@/components/CleanerOrders")
  },
  {
    path: "/orderCompleted",
    name: "orderCompleted",
    component: () => import("@/components/orders/OrderCompleted")
  },
  {
    path: "/profile",
    name: "profile",
    component: () => import("@/components/profile/profile")
  },
  {
    path: "/updateProfile",
    name: "updateProfile",
    component: () => import("@/components/profile/updateProfile")
  },
  {
    path: "/changePassword",
    name: "changePassword",
    component: () => import("@/components/profile/changePassword")
  },
  {
    path: "/newOrders",
    name: "newOrders",
    component: () => import("@/components/CleanerNewOrders")
  },
  {
    path: "/reviews",
    name: "reviews",
    component: () => import("@/components/reviews/CleanerReviews")
  },
  {
    path: "/termsAdministration",
    name: "termsAdministration",
    component: () => import("@/components/terms/TermsAdministration")
  },
  {
    path: "/termsAdministration2",
    name: "termsAdministration2",
    component: () => import("@/components/terms/TermsAdministration2")
  }
];

const router = new VueRouter({
  mode: "history",
  scrollBehavior () {
    document.getElementById('inspire').scrollIntoView()
  },
  base: process.env.BASE_URL+"/~torma6/dist/", //odkomentovat pri nasadeni
  routes
});

export default router;
